import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { openNewTab } from '../../../../utilities/index';
import { API_WHATSAPP } from '../../../../constants/public.constant';
import { 
    MonitorIcon, 
    ShieldIcon, 
    HeadphonesIcon, 
    NetworkIcon, 
    ZapIcon, 
    DollarSignIcon, 
    WrenchIcon, 
    DatabaseIcon 
} from '../../../../components/icons/ServiceIcons';
import { Phone, Mail, MapPin, FolderKanban, Users, Clock } from 'lucide-react';
import partner1 from '../../../../assets/img/desktop/Zebra_logo.png';
import partner2 from '../../../../assets/img/desktop/MicrosoftTeams-image.png';
import partner3 from '../../../../assets/img/desktop/Microsoft_logo_(2012).svg.png';
import partner4 from '../../../../assets/img/desktop/Partner4.jpg';
import partner5 from '../../../../assets/img/desktop/Partner6.jpg';
import partner6 from '../../../../assets/img/desktop/Bitdefender-Logo.wine.png';
import partner7 from '../../../../assets/img/desktop/Autodesk_Logo.svg.png';
import partner8 from '../../../../assets/img/desktop/351497.png';
import partner9 from '../../../../assets/img/desktop/350655.png';
import partner10 from '../../../../assets/img/desktop/2048px-HP_New_Logo_2D.svg.png';
import partner11 from '../../../../assets/img/desktop/1280px-Epson_logo.svg.png';
import partner12 from '../../../../assets/img/desktop/1200px-Kaspersky_Lab_logo.svg.png';
import partner13 from '../../../../assets/img/desktop/logo_heimdal_security.png';
import partner14 from '../../../../assets/img/desktop/Lenovo_logo_2015.svg.png';
import partner15 from '../../../../assets/img/desktop/Partner15.jpg';
import partner16 from '../../../../assets/img/desktop/Dell_Logo.svg.png';
import './CDHomeV2.css';

function CDHomeV2() {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [stPartners] = useState([partner1, partner2, partner3, partner4, partner5, partner6, partner7, partner8, partner9, partner10, partner11, partner12, partner13, partner14, partner15, partner16]);

    // Carrusel automático del hero
    useEffect(() => {
        const heroInterval = setInterval(() => {
            if (window.location.pathname === "/") {
                setCurrentSlide((prev) => (prev + 1) % 3);
            }
        }, 6000); // Cambiar cada 6 segundos
        
        return () => clearInterval(heroInterval);
    }, []);

    useEffect(() => {
        let idInterval = setInterval(() => {
            if (window.location.pathname === "/") {
                try {
                    moverCarruselpartner("derecha");
                }  catch(e) {
                    window.location.reload();
                }
                
            } else {
                window.clearInterval(idInterval);
            }
        }, 5000);
    }, []);

    function moverCarruselpartner(direccion: string) {
        let stContenidoPartner: any = document.getElementById("CDH2-c5Partner");

        if (direccion === "derecha") {
            let itemPrimeropartner = stContenidoPartner.childNodes[0];

            if (window.innerWidth < 1000) {
                stContenidoPartner.style.marginLeft = "-66.66%";
            }
            else {
                stContenidoPartner.style.marginLeft = "-50%";
            }
            stContenidoPartner.style.transition = "all .5s";

            setTimeout(() => {
                stContenidoPartner.style.transition = "none";
                stContenidoPartner.insertAdjacentElement('beforeend', itemPrimeropartner);

                if (window.innerWidth < 1000) {
                    stContenidoPartner.style.marginLeft = "-33.33%";
                }
                else {
                    stContenidoPartner.style.marginLeft = "-25%";
                }
            }, 500);
        }
        else {
            let itempartner = stContenidoPartner.childNodes;
            let itemfinalpartner = itempartner[itempartner.length - 1];

            stContenidoPartner.style.marginLeft = "0%";
            stContenidoPartner.style.transition = "all 0.5s"

            setTimeout(() => {
                stContenidoPartner.style.transition = "none";
                stContenidoPartner.insertAdjacentElement('afterbegin', itemfinalpartner);
                stContenidoPartner.style.marginLeft = "-33.33%";
            }, 500);
        }
    }

    function navigateView(name: string) {
        navigate("/" + name);
    }

    function openWhatsApp() {
        openNewTab(API_WHATSAPP);
    }

    return (
        <main id="CDHomeV2">
            {/* Hero Section V2 - Carrusel */}
            <section id="CDH2-c1">
                <div id="CDH2-c1__pattern"></div>
                <div id="CDH2-c1__carousel-container">
                    <div id="CDH2-c1__nav-left" onClick={() => setCurrentSlide((prev) => (prev - 1 + 3) % 3)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="#0A3058" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div id="CDH2-c1__carousel">
                        {/* Slide 1 */}
                        <div className={`CDH2-c1__slide ${currentSlide === 0 ? 'CDH2-c1__slide-active' : ''}`}>
                            <div id="CDH2-c1__content">
                                <div id="CDH2-c1__text">
                                    <h1 id="CDH2-c1__title">Soluciones integrales en<br />tecnología e infraestructura<br />industrial</h1>
                                    <p id="CDH2-c1__subtitle">Integramos tecnología, energía e ingeniería para garantizar continuidad operativa</p>
                                    <div id="CDH2-c1__buttons">
                                        <button id="CDH2-c1__btn-services" onClick={() => navigateView("")}>
                                            Ver Servicios
                                        </button>
                                        <button id="CDH2-c1__btn-contact" onClick={() => navigateView("Contacto")}>
                                            Contáctenos
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Slide 2 */}
                        <div className={`CDH2-c1__slide ${currentSlide === 1 ? 'CDH2-c1__slide-active' : ''}`}>
                            <div id="CDH2-c1__content">
                                <div id="CDH2-c1__text">
                                    <h1 id="CDH2-c1__title">Ciberseguridad de Alto Nivel</h1>
                                    <p id="CDH2-c1__subtitle">Protección avanzada contra amenazas, malware y ataques cibernéticos</p>
                                    <div id="CDH2-c1__buttons">
                                        <button id="CDH2-c1__btn-services" onClick={() => navigateView("Bitdefender")}>
                                            Conocer más
                                        </button>
                                        <button id="CDH2-c1__btn-contact" onClick={() => navigateView("Contacto")}>
                                            Consultar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Slide 3 */}
                        <div className={`CDH2-c1__slide ${currentSlide === 2 ? 'CDH2-c1__slide-active' : ''}`}>
                            <div id="CDH2-c1__content">
                                <div id="CDH2-c1__text">
                                    <h1 id="CDH2-c1__title">Continuidad Eléctrica para su<br />Empresa</h1>
                                    <p id="CDH2-c1__subtitle">UPS, estabilizadores, baterías y transformadores certificados</p>
                                    <div id="CDH2-c1__buttons">
                                        <button id="CDH2-c1__btn-services" onClick={() => navigateView("ContinuidadElectrica")}>
                                            Ver Soluciones
                                        </button>
                                        <button id="CDH2-c1__btn-contact" onClick={() => navigateView("Contacto")}>
                                            Solicitar Cotización
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="CDH2-c1__nav-right" onClick={() => setCurrentSlide((prev) => (prev + 1) % 3)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="#0A3058" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div id="CDH2-c1__indicators">
                    {[0, 1, 2].map((index) => (
                        <div
                            key={index}
                            className={`CDH2-indicator ${currentSlide === index ? 'CDH2-indicator-active' : ''}`}
                            onClick={() => setCurrentSlide(index)}
                        />
                    ))}
                </div>
                <div id="CDH2-c1__yellow-bar"></div>
            </section>

            {/* Sección de Servicios V2 */}
            <section id="CDH2-c2">
                <div id="CDH2-c2__header">
                    <div id="CDH2-c2__header-left">
                        <p id="CDH2-c2__subtitle">NUESTRAS SOLUCIONES</p>
                        <h2 id="CDH2-c2__title">Servicios Integrales para su Empresa</h2>
                        <p id="CDH2-c2__description">Ofrecemos soluciones completas en tecnología e infraestructura industrial</p>
                    </div>
                </div>
                <div id="CDH2-c2__services-grid">
                    <div className="CDH2-service-card" onClick={() => navigateView("Infraestructura")}>
                        <div className="CDH2-service-card__icon">
                            <MonitorIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Infraestructura TI</h3>
                        <p className="CDH2-service-card__description">Servidores, redes, virtualización y data centers empresariales</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("Infraestructura"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card" onClick={() => navigateView("Bitdefender")}>
                        <div className="CDH2-service-card__icon">
                            <ShieldIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Ciberseguridad</h3>
                        <p className="CDH2-service-card__description">Protección avanzada contra amenazas y ataques</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("Bitdefender"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card" onClick={() => navigateView("Helpdesk")}>
                        <div className="CDH2-service-card__icon">
                            <HeadphonesIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Soporte Técnico</h3>
                        <p className="CDH2-service-card__description">Monitoreo 24/7 y planes de continuidad operativa</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("Helpdesk"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card" onClick={() => navigateView("Networking")}>
                        <div className="CDH2-service-card__icon">
                            <NetworkIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Networking</h3>
                        <p className="CDH2-service-card__description">Soluciones de conectividad y comunicaciones</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("Networking"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card CDH2-service-card--yellow" onClick={() => navigateView("ContinuidadElectrica")}>
                        <div className="CDH2-service-card__icon">
                            <ZapIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Continuidad Eléctrica</h3>
                        <p className="CDH2-service-card__description">UPS, estabilizadores y transformadores certificados</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("ContinuidadElectrica"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card CDH2-service-card--yellow" onClick={() => navigateView("InfraestructuraElectrica")}>
                        <div className="CDH2-service-card__icon">
                            <DollarSignIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Infraestructura Eléctrica</h3>
                        <p className="CDH2-service-card__description">Tableros eléctricos y sistemas de protección</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("InfraestructuraElectrica"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card CDH2-service-card--yellow" onClick={() => navigateView("MantenimientoIndustrial")}>
                        <div className="CDH2-service-card__icon">
                            <WrenchIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Mantenimiento Industrial</h3>
                        <p className="CDH2-service-card__description">Equipos hidráulicos y sistemas críticos</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("MantenimientoIndustrial"); }}>Ver más →</a>
                    </div>
                    <div className="CDH2-service-card" onClick={() => navigateView("Infraestructura")}>
                        <div className="CDH2-service-card__icon">
                            <DatabaseIcon />
                        </div>
                        <h3 className="CDH2-service-card__title">Data Center</h3>
                        <p className="CDH2-service-card__description">Diseño e implementación de centros de datos</p>
                        <a className="CDH2-service-card__link" onClick={(e) => { e.stopPropagation(); navigateView("Infraestructura"); }}>Ver más →</a>
                    </div>
                </div>
            </section>

            {/* Sección Quiénes Somos V2 */}
            <section id="CDH2-c3">
                <div id="CDH2-c3__content">
                    <div id="CDH2-c3__left">
                        <p id="CDH2-c3__subtitle">QUIÉNES SOMOS</p>
                        <h2 id="CDH2-c3__title">Su aliado estratégico en tecnología e infraestructura</h2>
                        <p id="CDH2-c3__description1">En Infra-Sol somos un equipo apasionado y dedicado de asesores y consultores especializados en comunicaciones, infraestructura y seguridad informática.</p>
                        <p id="CDH2-c3__description2">Integramos tecnología, energía e ingeniería industrial para garantizar continuidad operativa, seguridad y alto desempeño en entornos críticos.</p>
                        <ul id="CDH2-c3__features">
                            <li>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span>Más de 15 años de experiencia</span>
                            </li>
                            <li>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span>Equipo certificado y especializado</span>
                            </li>
                            <li>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span>Soporte técnico 24/7</span>
                            </li>
                            <li>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span>Soluciones a medida</span>
                            </li>
                        </ul>
                        <button id="CDH2-c3__btn" onClick={() => navigateView("Nosotros")}>
                            Conocer más
                        </button>
                    </div>
                    <div id="CDH2-c3__right">
                        <div className="CDH2-c3__stat-card">
                            <div className="CDH2-c3__stat-icon">
                                <FolderKanban size={40} stroke="#DDB70F" strokeWidth={2} />
                            </div>
                            <div className="CDH2-c3__stat-content">
                                <p className="CDH2-c3__stat-number">500+</p>
                                <p className="CDH2-c3__stat-label">Proyectos completados</p>
                            </div>
                        </div>
                        <div className="CDH2-c3__stat-card">
                            <div className="CDH2-c3__stat-icon">
                                <Users size={40} stroke="#DDB70F" strokeWidth={2} />
                            </div>
                            <div className="CDH2-c3__stat-content">
                                <p className="CDH2-c3__stat-number">200+</p>
                                <p className="CDH2-c3__stat-label">Clientes satisfechos</p>
                            </div>
                        </div>
                        <div className="CDH2-c3__stat-card">
                            <div className="CDH2-c3__stat-icon">
                                <Clock size={40} stroke="#DDB70F" strokeWidth={2} />
                            </div>
                            <div className="CDH2-c3__stat-content">
                                <p className="CDH2-c3__stat-number">15+</p>
                                <p className="CDH2-c3__stat-label">Años de experiencia</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sección Call to Action */}
            <section id="CDH2-c4">
                <div id="CDH2-c4__content">
                    <div id="CDH2-c4__left">
                        <h2 id="CDH2-c4__title">¿Listo para potenciar su infraestructura?</h2>
                        <p id="CDH2-c4__subtitle">Contáctenos hoy y reciba una evaluación gratuita de sus necesidades tecnológicas</p>
                        <div id="CDH2-c4__buttons">
                            <button id="CDH2-c4__btn-diagnosis" onClick={() => navigateView("Contacto")}>
                                Solicitar Diagnóstico
                            </button>
                            <button id="CDH2-c4__btn-services" onClick={() => navigateView("")}>
                                Ver Servicios
                            </button>
                        </div>
                    </div>
                    <div id="CDH2-c4__right">
                        <div className="CDH2-c4__contact-item">
                            <Phone size={32} stroke="#DDB70F" fill="none" strokeWidth={2} />
                            <div>
                                <p className="CDH2-c4__contact-label">LLÁMENOS</p>
                                <p className="CDH2-c4__contact-value">+51(1) 739-2588</p>
                            </div>
                        </div>
                        <div className="CDH2-c4__contact-item">
                            <Mail size={32} stroke="#DDB70F" fill="none" strokeWidth={2} />
                            <div>
                                <p className="CDH2-c4__contact-label">ESCRÍBANOS</p>
                                <p className="CDH2-c4__contact-value">ventas@infra-sol.com</p>
                            </div>
                        </div>
                        <div className="CDH2-c4__contact-item">
                            <MapPin size={32} stroke="#DDB70F" fill="none" strokeWidth={2} />
                            <div>
                                <p className="CDH2-c4__contact-label">VISÍTENOS</p>
                                <p className="CDH2-c4__contact-value">Miraflores, Lima</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sección Partners */}
            <section id="CDH2-c5">
                <div id="CDH2-c5__partner">
                    <div id="CDH2-c5__partner--text">
                        <h3 id="CDH2-c5__title"><span id="CDH2-c5__title-top">CONFÍAN EN NOSOTROS</span> <strong>Nuestros Partners y Clientes</strong></h3>
                        <div>
                            <ul id="CDH2-c5Partner">
                                {
                                    stPartners.map((item, index) => (
                                        <li key={index} className="CDH2-c5__partner--item">
                                            <img src={item} alt="Infrasol Partners" />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Botón flotante WhatsApp */}
            <div id="CDH2-whatsapp-float" onClick={openWhatsApp}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="white"/>
                </svg>
                <span>Contáctenos vía WhatsApp</span>
            </div>
        </main>
    );
}

export default CDHomeV2;

